import { useLayoutEffect } from "react";
/**
 * Hook to lock and unlock body scroll.
 *
 * @param {Boolean} active A boolean indicating if this hook is active
 */

export default function useLockBodyScroll(active) {
  useLayoutEffect(() => {
    if (active) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }
  }, [active]);
}